import React from 'react';
import { useDayPicker } from '../DayPicker/useDayPicker.js';
import '../DayPicker/DayPickerContext.js';
import { useNavigationState } from './useNavigationState.js';
import { getDisplayMonths } from './utils/getDisplayMonths.js';
import { getNextMonth } from './utils/getNextMonth.js';
import { getPreviousMonth } from './utils/getPreviousMonth.js';

/**
 * The Navigation context shares details about the months being navigated in DayPicker.
 *
 * Access this context from the [[useNavigation]] hook.
 */
var NavigationContext = React.createContext(undefined);
/** Provides the values for the [[NavigationContext]]. */
function NavigationProvider(props) {
    var context = useDayPicker();
    var _a = useNavigationState(), month = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(month, context);
    var nextMonth = getNextMonth(month, context);
    var previousMonth = getPreviousMonth(month, context);
    return (React.createElement(NavigationContext.Provider, { value: {
            month: month,
            displayMonths: displayMonths,
            goToMonth: goToMonth,
            previousMonth: previousMonth,
            nextMonth: nextMonth
        } }, props.children));
}

export { NavigationContext, NavigationProvider };
//# sourceMappingURL=NavigationContext.js.map
